import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { UserService } from "./user.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private userService: UserService, private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available - falls back to the
    // pending (pre-login) token during registration so Stripe checkout/verify
    // calls can authenticate before the user is actually logged in
    const token = this.userService.getAuthToken();

    const headers: { [key: string]: string } = {};

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Add appPlatform header if running in mobile app (stored in localStorage)
    const appPlatform = localStorage.getItem('appPlatform');
    if (appPlatform === 'Android' || appPlatform === 'iOS') {
      headers['appPlatform'] = appPlatform;
    }

    if (Object.keys(headers).length > 0) {
      request = request.clone({
        setHeaders: headers,
      });
    }

    // nodebb_token is minted on login/register/NodeBBSession/CompleteOnboarding, re-minted on
    // ChangeUnconfirmedEmail (the new address is a claim inside it), and cleared on logout; the
    // browser only honours Set-Cookie on a cross-origin response when the request is
    // credentialed. Any endpoint that mints the cookie must be listed here or the browser
    // silently drops it.
    if (
      /\/api\/Account\/(Login|SelfRegister|Logout|NodeBBSession|CompleteOnboarding|ChangeUnconfirmedEmail)$/i.test(
        request.url
      )
    ) {
      request = request.clone({ withCredentials: true });
    }

    return next.handle(request).pipe(
      tap(
        () => {},
        (err: any) => {
          // console.log("Is this going to dump??", err);
          if (err instanceof HttpErrorResponse) {
            let failedCalls = [];

            if (localStorage.getItem("failedCalls")) {
              failedCalls = JSON.parse(localStorage.getItem("failedCalls"));
            }

            failedCalls.unshift({
              url: err.url,
              message: err.message,
            });

            localStorage.setItem("failedCalls", JSON.stringify(failedCalls));

            // let calls: string[] = [];
            // let deets: string[] = [];
            // var callsData = JSON.parse(localStorage.getItem('failedCalls'));
            // var deetsData = JSON.parse(localStorage.getItem('failureDeets'));
            // if (callsData !== null && deetsData !== null) {
            //   calls.push(JSON.parse(localStorage.getItem('failedCalls')));
            //   deets.push(JSON.parse(localStorage.getItem('failureDeets')));
            // }
            // calls.push(err.url);
            // deets.push(err.message);
            // localStorage.setItem('failedCalls', JSON.stringify(calls));
            // localStorage.setItem('failureDeets', JSON.stringify(deets));
            // Need to save these to localstorage as well.
            // NodeBBSession backs the community forum SSO/warmup call, not the user's actual
            // app session - a 401 there (e.g. NodeBB config/shared-secret issues) must not be
            // treated as "your login expired" and bounce the whole app to the login screen.
            const isCommunitySessionCall = /\/api\/Account\/NodeBBSession$/i.test(err.url ?? "");

            if (err.status === 401 && !isCommunitySessionCall) {
              const wasOnlyPending =
                !this.userService.isUserLoggedIn() &&
                this.userService.hasPendingAuth();
              this.userService.logoutOnTokenExp();
              if (wasOnlyPending) {
                this.userService.clearPendingAuth();
                this.router.navigate(["register"]);
              } else {
                this.router.navigate(["login"]);
              }
            }
          }
        }
      )
    );
  }
}
